import {Exceptions} from '../../../panels/user/editTeamAssignmentsPanel/constants'
import {Exceptions as CommonExceptions} from '../../../common/constants'

export function rpcErrorHandler(rpcError) {
    rpcError.handleOnException(
        Exceptions.NoSuchUserException,
        Exceptions.UserHasAccessToAllScopeException,
        CommonExceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION,
        CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION
    )
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsEditor/utils.js